import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const ISpeechService = ( createDecorator('speechService'));
export { ISpeechService };
